import { render, staticRenderFns } from "./SaleServiceInvoiceA4.vue?vue&type=template&id=796f1d91&"
import script from "./SaleServiceInvoiceA4.vue?vue&type=script&lang=js&"
export * from "./SaleServiceInvoiceA4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports